import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

import useRmfUKDefaultFlow from './UK/useRmfUKDefaultFlow';
import useRmfUKPfpFirstFlow from './UK/useRmfUKPfpFirstFlow';
import useRmfUKPhoneAfterAddressFlow from './UK/useRmfUKPhoneAfterAddressFlow';
import useRmfUKPhoneAfterNameFlow from './UK/useRmfUKPhoneAfterNameFlow';

const useRmfUKFlow = () => {
  const swcRmfUKPhoneAfterAddress = useFeature(FeatureFlag.SwcRmfUKPhoneAfterAddress);
  const swcRmfUKPhoneAfterName = useFeature(FeatureFlag.SwcRmfUKPhoneAfterName);
  const swcRmfUKPlayerFundsProtectionFirst = useFeature(
    FeatureFlag.SwcRmfUKPlayerFundsProtectionFirst
  );

  if (swcRmfUKPhoneAfterName) {
    return useRmfUKPhoneAfterNameFlow();
  } else if (swcRmfUKPhoneAfterAddress) {
    return useRmfUKPhoneAfterAddressFlow();
  } else if (swcRmfUKPlayerFundsProtectionFirst) {
    return useRmfUKPfpFirstFlow();
  } else {
    return useRmfUKDefaultFlow();
  }
};

export default useRmfUKFlow;
